import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Button,
  Card,
  Label,
  TextInput,
  FileInput,
  Spinner,
  Select,
} from "flowbite-react";
import { API_BASE_URL } from "../../config";

const Settings = () => {
  const [configuraciones, setConfiguraciones] = useState({
    logo: "static/images/default-logo.png",
    cardColor: "#f0f0f0",
    textColor: "#000000",
    cardBorderRadius: "8px",
    fontSize: "16px",
    fontFamily: "Arial",
    nombre_restaurante: "",
    telefono_contacto: "",
    ubicacion_google_maps: "",

  });
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const clienteId = searchParams.get("cliente_id");

  useEffect(() => {
const fetchConfiguraciones = async () => {
  setLoading(true);
  try {
    const timestamp = new Date().getTime(); // Genera un timestamp único
    const response = await fetch(`${API_BASE_URL}/configuraciones?cliente_id=${clienteId}`);

    if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);

    const data = await response.json();
    console.log("📌 Configuraciones obtenidas:", data);

    setConfiguraciones((prev) => {
      const updatedConfig = {
        ...prev,
        ...data,
        logo: data.logo || prev.logo,
        backgroundImage: data.backgroundImage || prev.backgroundImage,
        cardColor: data.cardColor || prev.cardColor || "#f0f0f0",
      };

      // 🔥 Eliminar backgroundColor si está presente
      delete updatedConfig.backgroundColor;

      return updatedConfig;
    });

  } catch (error) {
    console.error("❌ Error al cargar configuraciones:", error);
  } finally {
    setLoading(false);
  }
};

    fetchConfiguraciones();
  }, [clienteId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setConfiguraciones({ ...configuraciones, [name]: value });
  };

  const handleFileChange = async (e) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      const file = files[0];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("cliente_id", clienteId);

      try {
        const endpoint =
          name === "logoFile"
            ? `${API_BASE_URL}/configuraciones/logo`
            : `${API_BASE_URL}/configuraciones/background`;

        const response = await fetch(endpoint, {
          method: "POST",
          body: formData,
        });

        if (!response.ok) throw new Error(`Error al subir archivo: ${response.status}`);
        const data = await response.json();

        setConfiguraciones((prev) => ({
          ...prev,
          [name === "logoFile" ? "logo" : "backgroundImage"]: `${data.url}?v=${new Date().getTime()}`, // Añade timestamp
        }));
      } catch (error) {
        console.error("Error al subir imagen:", error);
      }
    }
  };

const handleSubmit = async (e) => {
  e.preventDefault();

  // 🔥 Eliminar backgroundColor y asegurar cardColor
  const { backgroundColor, ...filteredConfig } = {
    ...configuraciones,
    cliente_id: clienteId,
    cardColor: configuraciones.cardColor || "#f0f0f0", // 🔥 Asegurar cardColor
  };

  console.log("📤 Datos enviados:", filteredConfig); // Debugging

  try {
    setLoading(true);
    const response = await fetch(`${API_BASE_URL}/configuraciones`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(filteredConfig), // 🚀 Enviar sin backgroundColor
    });

    if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);
    alert("✅ Configuraciones actualizadas exitosamente.");
  } catch (error) {
    console.error("❌ Error al actualizar configuraciones:", error);
  } finally {
    setLoading(false);
  }
};

  const constructUrl = (path) => {
  const timestamp = new Date().getTime(); // Genera un timestamp único
  if (path.startsWith("http")) {
    return `${path}?v=${timestamp}`; // Si es una URL absoluta, añade el timestamp
  }
  return `${API_BASE_URL}/${path}?v=${timestamp}`; // Para rutas relativas, añade el timestamp
};


  return (
    <div
      className="min-h-screen p-8"
      style={{
        color: configuraciones.textColor,
        fontFamily: configuraciones.fontFamily,
      }}
    >
      <h1 className="text-3xl font-bold text-center mb-8">Configuraciones</h1>
      {loading && (
        <div className="flex justify-center mb-4">
          <Spinner size="lg" />
        </div>
      )}
      <Card style={{ backgroundColor: configuraciones.cardColor }}>
        <form onSubmit={handleSubmit}>
          <InputGroup
            label="Logo"
            id="logoFile"
            value={configuraciones.logo}
            onFileChange={handleFileChange}
            constructUrl={constructUrl}
          />
    
<ColorPicker
  label="Color de Tarjetas"
  id="cardColor"
  value={configuraciones.cardColor}
  onChange={handleInputChange}
/>


      <InputGroup
            label="Fondo"
            id="backgroundFile"
            value={configuraciones.backgroundImage}
            onFileChange={handleFileChange}
            constructUrl={constructUrl}
             />
          <TextInput
           label="Nombre del Restaurante"
           id="nombre_restaurante"
           name="nombre_restaurante"
           value={configuraciones.nombre_restaurante}
           onChange={handleInputChange}
            />
          <TextInput
           label="Teléfono de Contacto"
           id="telefono_contacto"
           name="telefono_contacto"
           value={configuraciones.telefono_contacto}
           onChange={handleInputChange}
            />
          <TextInput
           label="Ubicación en Google Maps"
           id="ubicacion_google_maps"
           name="ubicacion_google_maps"
           value={configuraciones.ubicacion_google_maps}
           onChange={handleInputChange}
            />
          <ColorPicker
            label="Color del Texto"
            id="textColor"
            value={configuraciones.textColor}
            onChange={handleInputChange}
          />
          <NumberInput
            label="Tamaño de Fuente (px)"
            id="fontSize"
            value={parseInt(configuraciones.fontSize)}
            onChange={(value) => handleInputChange({ target: { name: "fontSize", value } })}
          />
          <NumberInput
            label="Bordes de las Tarjetas (px)"
            id="cardBorderRadius"
            value={parseInt(configuraciones.cardBorderRadius)}
            onChange={(value) =>              handleInputChange({ target: { name: "cardBorderRadius", value } })
            }
          />
          <SelectInput
            label="Familia de Fuente"
            id="fontFamily"
            value={configuraciones.fontFamily}
            options={["Arial", "Verdana", "Tahoma", "Georgia", "Times New Roman", "Courier New"]}
            onChange={handleInputChange}
          />
          <Button type="submit" gradientDuoTone="cyanToBlue" className="w-full">
            Guardar Configuraciones
          </Button>
        </form>
      </Card>
    </div>
  );
};

const InputGroup = ({ label, id, value, onFileChange, constructUrl }) => (
  <div className="mb-6">
    <Label htmlFor={id}>{label}:</Label>
    <FileInput id={id} name={id} accept="image/*" onChange={onFileChange} />
    {value && (
      <div className="mt-4">
        <img src={constructUrl(value)} alt={label} className="w-40 h-auto mx-auto" />
      </div>
    )}
  </div>
);

const ColorPicker = ({ label, id, value, onChange }) => (
  <div className="mb-6">
    <Label htmlFor={id}>{label}:</Label>
    <input type="color" id={id} name={id} value={value} onChange={onChange} className="w-full" />
  </div>
);

const NumberInput = ({ label, id, value, onChange }) => (
  <div className="mb-6">
    <Label htmlFor={id}>{label}:</Label>
    <TextInput
      type="number"
      id={id}
      name={id}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  </div>
);

const SelectInput = ({ label, id, value, options, onChange }) => (
  <div className="mb-6">
    <Label htmlFor={id}>{label}:</Label>
    <Select id={id} name={id} value={value} onChange={onChange}>
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </Select>
  </div>
);

export default Settings;
